import React, { useState } from "react";
import isDowngrading from "../utils/isDowngrading";
import isUpgrading from "../utils/isUpgrading";
import NewModal from "../../../../modal/NewModal";
import Checkbox from "../../../../../../lib/Checkbox/Checkbox";
import { compose } from "redux";
import withTranslations from "../../../../../../hocs/withTranslations";

const PaymentModal = ({
  translate,
  price,
  selectedPlanName,
  description,
  onPaymentButtonClick,
  selectedPlan,
  userData,
  hideModal
}) => {
  const [errors, setErrors] = useState({ agreement_content: null });
  const [formState, setFormState] = useState({
    agreement_content: false
  });

  const validate = () => {
    const errors = {
      agreement_content: null
    };

    if (selectedPlan?.agreement_content && !formState.agreement_content) {
      errors.agreement_content = translate("This field is required");
    }

    if (errors.agreement_content) {
      setErrors(errors);
      return false;
    }

    return true;
  };

  const handleSubmit = async () => {
    const isValid = validate();

    if (isValid) {
      await onPaymentButtonClick();
    }
  };

  let paragraph = translate("plans_payment-bar_modal-description");

  if (
    isDowngrading({
      userCurrentPlan: userData?.current_plan,
      selectedPlan
    })
  ) {
    paragraph = translate("plans_payment-bar_downgrading_modal-description");
  } else if (
    isUpgrading({
      userCurrentPlan: userData?.current_plan,
      selectedPlan
    })
  ) {
    paragraph = translate("plans_payment-bar_upgrading_modal-description");
  }

  return (
    <NewModal
      canHide={validate}
      title={translate("plans_payment-bar_modal-title")}
      acceptButtonText={translate("plans_payment-bar_modal-accept-button-text")}
      onAccept={handleSubmit}
      cancelButtonText={translate("Cancel")}
      hideModal={hideModal}
      onClose={() => {
        hideModal?.();
      }}
    >
      <p className={"text-sm text-black opacity-70 mb-6"}>{paragraph}</p>
      <div className={"bg-gray rounded p-4 flex flex-col gap-6"}>
        {selectedPlanName}
        {price}
        {description}
      </div>
      {selectedPlan?.agreement_content ? (
        <div className={"mt-4"}>
          <Checkbox
            errorMessage={errors.agreement_content}
            onClick={() =>
              setFormState(prevState => ({
                ...prevState,
                agreement_content: !prevState.agreement_content
              }))
            }
            checked={formState.agreement_content}
            className={"text-black-8"}
            label={selectedPlan.agreement_content}
          />
        </div>
      ) : null}
    </NewModal>
  );
};

export default compose(withTranslations)(PaymentModal);
